export default {
  label: 'Adicionar domínio'
}
